export const SELECTABLE_CLASS = 'selectable';
export const ID_PREFIX = 'id-';
export const DATA_ELEMENT_PREFIX = 'data-element-';
export const MJ = {
  HEAD: 'mj-head',
  ATTRIBUTES: 'mj-attributes',
  BODY: 'mj-body',
  SECTION: 'mj-section',
  WRAPPER: 'mj-wrapper',
  COLUMN: 'mj-column',
  GROUP: 'mj-group',
  HERO: 'mj-hero',
  TEXT: 'mj-text',
  IMAGE: 'mj-image',
  BUTTON: 'mj-button',
  DIVIDER: 'mj-divider',
  SPACER: 'mj-spacer',
  SOCIAL: 'mj-social',
  SOCIAL_ELEMENT: 'mj-social-element',
  NAVBAR: 'mj-navbar',
  NAVBAR_LINK: 'mj-navbar-link',
  ACCORDION: 'mj-accordion',
  ACCORDION_ELEMENT: 'mj-accordion-element',
  CAROUSEL: 'mj-carousel',
  TABLE: 'mj-table',
  RAW: 'mj-raw',
  CLASS: 'mj-class',
  ALL: 'mj-all'
};
/**
 * The named `mj-class` presets a theme defines in its `mj-head` and email bodies reference.
 * This is the vocabulary that keeps a body theme-agnostic — anything emitting or reading a
 * `mj-class` must use these names, not string literals.
 */
export const MJ_CLASS_NAMES = {
  HEADING_TEXT: 'heading-text',
  PARAGRAPH_TEXT: 'paragraph-text',
  SECTION: 'section',
  SECTION_FOOTER: 'section-footer',
  SUB_HEADING_TEXT: 'sub-heading-text',
  STYLISED_TEXT: 'stylised-text',
  TEXT_FOOTER: 'text-footer',
  PRIMARY_BUTTON: 'primary-button',
  SECONDARY_BUTTON: 'secondary-button',
  CONTRAST_SECTION: 'contrast-section',
  IMAGE: 'image',
  LOGO: 'logo',
  DIVIDER: 'divider'
};
export const EDITABLE_ELEMENTS = [MJ.TEXT, MJ.BUTTON];
export const SELECTABLE_ELEMENTS = [MJ.ACCORDION, MJ.BUTTON, MJ.CAROUSEL, MJ.DIVIDER, MJ.HERO, MJ.IMAGE, MJ.NAVBAR, MJ.RAW, MJ.SECTION, MJ.SOCIAL, MJ.SPACER, MJ.TABLE, MJ.TEXT];
const COLUMN_OR_HERO = [MJ.COLUMN, MJ.HERO];
export const VALID_PARENTS = {
  [MJ.ACCORDION]: COLUMN_OR_HERO,
  [MJ.BUTTON]: COLUMN_OR_HERO,
  [MJ.CAROUSEL]: COLUMN_OR_HERO,
  [MJ.DIVIDER]: COLUMN_OR_HERO,
  [MJ.IMAGE]: COLUMN_OR_HERO,
  [MJ.NAVBAR]: COLUMN_OR_HERO,
  [MJ.RAW]: COLUMN_OR_HERO,
  [MJ.SOCIAL]: COLUMN_OR_HERO,
  [MJ.SPACER]: COLUMN_OR_HERO,
  [MJ.TABLE]: COLUMN_OR_HERO,
  [MJ.TEXT]: COLUMN_OR_HERO,
  [MJ.ACCORDION_ELEMENT]: [MJ.ACCORDION],
  [MJ.NAVBAR_LINK]: [MJ.NAVBAR],
  [MJ.SOCIAL_ELEMENT]: [MJ.SOCIAL],
  [MJ.COLUMN]: [MJ.SECTION, MJ.GROUP],
  [MJ.GROUP]: [MJ.SECTION],
  [MJ.HERO]: [MJ.BODY, MJ.WRAPPER],
  [MJ.SECTION]: [MJ.BODY, MJ.WRAPPER],
  [MJ.WRAPPER]: [MJ.BODY]
};
//# sourceMappingURL=elements.js.map